import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Thunk to fetch demo video/doc content for a module by its module_name
export const fetchDemoContentByModule = createAsyncThunk(
  "demoContent/fetchDemoContentByModule",
  async (moduleName, { rejectWithValue }) => {
    try {
      const formatModuleName = moduleName.toLowerCase();
      const res = await axios.get(
        `/demo-content/module-by-name/${formatModuleName}`,
      );

      return { moduleName, data: res.data?.data || null };
    } catch (err) {
      return rejectWithValue({
        moduleName,
        error: err.response?.data?.message || err.message,
      });
    }
  },
);

const initialState = {
  dataByModule: {}, // keyed by module name
  loadingByModule: {},
  errorByModule: {},
};

const demoContentSlice = createSlice({
  name: "demoContent",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDemoContentByModule.pending, (state, action) => {
        state.loadingByModule[action.meta.arg] = true;
        state.errorByModule[action.meta.arg] = null;
      })
      .addCase(fetchDemoContentByModule.fulfilled, (state, action) => {
        const { moduleName, data } = action.payload;
        state.loadingByModule[moduleName] = false;
        state.dataByModule[moduleName] = data;
      })
      .addCase(fetchDemoContentByModule.rejected, (state, action) => {
        const { moduleName, error } = action.payload || {};
        state.loadingByModule[moduleName] = false;
        state.errorByModule[moduleName] = error || "Something went wrong";
      });
  },
});

export const selectDemoContentByModule = (moduleName) => (state) =>
  state.demoContent.dataByModule[moduleName];
export const selectDemoContentLoading = (moduleName) => (state) =>
  state.demoContent.loadingByModule[moduleName];

export default demoContentSlice.reducer;
